export default {
  USD: "$",
  EUR: "€",
  GBP: "£",
  NZD: "$",
  AUD: "$",
  CAD: "$",
  INR: "₹",
};
